import React from 'react'
import { useSelector } from 'react-redux'
import { IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/react'
import './Header.component.css'
import OfflineIndicator from '../offlineIndicator/OfflineIndicator.component'
import { getStyleForPHI, IPHIComponent } from '../phi/phi.component'
import { hasNewNotificationsSelector } from '../../features/notificationCenter/selectors'

interface IHeaderProps extends IPHIComponent {
  title: string | JSX.Element
  showMenuButton?: boolean
}
const Header: React.FC<IHeaderProps> = (props: IHeaderProps) => {
  const { title, isPHI, showMenuButton = true } = props
  const hasNewNotifications = useSelector(hasNewNotificationsSelector)

  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot='end'>
          <OfflineIndicator />
          {showMenuButton && (
            <div className='header-menu-btn-wrapper'>
              <IonMenuButton color='primary-alt' />
              {hasNewNotifications && <span className='header-notification-dot' />}
            </div>
          )}
        </IonButtons>
        <IonTitle data-private={isPHI} style={getStyleForPHI(isPHI)} data-testid='HeaderLabel'>
          <div className='title-wrap'> {title} </div>
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  )
}

export default Header
